import { getRaw, postRaw, putRaw, deleteRaw } from 'services/api';

export const ANALYTICS_METRIC_DEFINITIONS_URL = '/analyticsMetricDefinitions';
export const HIGH_LEVEL_METRIC_DEFINITIONS_URL = '/highLevelMetricDefinitions';

export const getAnalyticsMetricDefinitions = (page) => {
  return getRaw(`${ANALYTICS_METRIC_DEFINITIONS_URL}${page ? `?page=${page}` : ''}`);
};

export const getAnalyticsMetricDefinitionsById = (id) => {
  return getRaw(`${ANALYTICS_METRIC_DEFINITIONS_URL}/${id}`);
};

export const createAnalyticsMetricDefinition = (request) => {
  return postRaw(ANALYTICS_METRIC_DEFINITIONS_URL, request.postData);
};

export const updateAnalyticsMetricDefinition = (request) => {
  return putRaw(`${ANALYTICS_METRIC_DEFINITIONS_URL}/${request.id}`, request.postData);
};

export const deleteAnalyticsMetricDefinition = (request) => {
  return deleteRaw(`${ANALYTICS_METRIC_DEFINITIONS_URL}/${request.id}`);
};

export const bulkUpdateAnalyticsMetricDefinition = (request) => {
  return postRaw(`${ANALYTICS_METRIC_DEFINITIONS_URL}/csv`, request.postData);
};

export const getHighLevelMetricDefinitions = (page) => {
  return getRaw(`${HIGH_LEVEL_METRIC_DEFINITIONS_URL}${page ? `?page=${page}` : ''}`);
};

export const getHighLevelMetricDefinitionsById = (id) => {
  return getRaw(`${HIGH_LEVEL_METRIC_DEFINITIONS_URL}/${id}`);
};

export const createHighLevelMetricDefinition = (request) => {
  return postRaw(HIGH_LEVEL_METRIC_DEFINITIONS_URL, request.postData);
};

export const updateHighLevelMetricDefinition = (request) => {
  return putRaw(`${HIGH_LEVEL_METRIC_DEFINITIONS_URL}/${request.id}`, request.postData);
};

export const deleteHighLevelMetricDefinition = (request) => {
  return deleteRaw(`${HIGH_LEVEL_METRIC_DEFINITIONS_URL}/${request.id}`);
};

export const bulkUpdateHighLevelMetricDefinition = (request) => {
  return postRaw(`${HIGH_LEVEL_METRIC_DEFINITIONS_URL}/csv`, request.postData);
};
